import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { callMsGraph } from '../../../utils/MsGraphApiCall';
import { GraphData } from '../../common/components';

/**
 * Fetches the current user's MS Graph profile once and caches the result.
 * Replaces the duplicated callMsGraph() pattern across customer info fields.
 */
export const useGraphProfile = () => {
  const { inProgress } = useMsal();
  const [graphData, setGraphData] = useState<GraphData | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!graphData && inProgress === InteractionStatus.None) {
      callMsGraph()
        .then(setGraphData)
        .catch((err: unknown) => setError(err instanceof Error ? err : new Error(String(err))));
    }
  }, [graphData, inProgress]);

  return { graphData, error };
};
